<template>
  <el-drawer title=""
             :visible.sync="advertisingBannerVisible"
             direction="ttb"
             size="50%"
             @close="advertisingBannerVisibleClose">
    <el-image style="width: 100%; height: 100%"
              :src="advertiDetail.pcImgUrl"
              fit="fit"></el-image>

  </el-drawer>
</template>
<script>
import { AdDetails } from "@/utils/mixin";

export default {
  props: {
    visible: Boolean,
  },
  mixins: [AdDetails],
  data () {
    return {
      advertiDetail: '',
      advertisingBannerVisible: false,
      flag: false
    };
  },
  methods: {

    advertisingBannerVisibleClose () {
      this.$emit("close");
    },
  },
  watch: {
    visible (val) {
      this.getAdDetails('eabe9742-7dfc-49b0-82bd-8702064a26a7', this, 'advertiDetail');
      this.flag = val;
    },
    advertiDetail (val) {
      let isRead = Boolean(localStorage.getItem('advertisingBannerVisible'))
      if (val && val.pcImgUrl && !val.isStop && !isRead) {
        this.advertisingBannerVisible = this.flag
        localStorage.setItem('advertisingBannerVisible', true)
      }
    },
  },
};
</script>
<style lang="less" scoped>
.advertisement {
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>